import React from 'react';

export function SectionTitle(props: {
  title: React.ReactElement | string;
  subtitle?: React.ReactElement | string;
}) {
  return (
    <div>
      {props.title}{' '}
      {props.subtitle && (
        <span className="form-line-item-subtitle">{props.subtitle}</span>
      )}
    </div>
  );
}

export function BaseItem(props: {
  description?: React.ReactElement | string | null;
  title?: React.ReactElement | string;
  subtitle?: React.ReactElement | string;
  value?: React.ReactElement | string | null;
  containerClassName: string;
  descriptionClassName: string;
  valueClassName: string;
}) {
  let descriptionElement = null;
  if (props.description) {
    descriptionElement = props.description;
  } else if (props.title) {
    descriptionElement = (
      <SectionTitle title={props.title} subtitle={props.subtitle} />
    );
  }

  return (
    <div className={props.containerClassName}>
      <div className={props.descriptionClassName}>{descriptionElement}</div>
      <div className={props.valueClassName}>{props.value}</div>
    </div>
  );
}

export function LineItem(props: {
  description?: React.ReactElement | string;
  title?: React.ReactElement | string;
  subtitle?: React.ReactElement | string;
  value: React.ReactElement | string | null;
}) {
  return (
    <BaseItem
      description={props.description}
      title={props.title}
      subtitle={props.subtitle}
      value={props.value !== null ? props.value : 'N/A'}
      containerClassName="form-line-item"
      descriptionClassName="form-line-item-description"
      valueClassName="form-line-item-value"
    />
  );
}

export function SectionItem(props: {
  description?: React.ReactElement | string | null;
  title?: React.ReactElement | string;
  subtitle?: React.ReactElement | string;
  value?: React.ReactElement | string | null;
}) {
  return (
    <BaseItem
      description={props.description}
      title={props.title}
      subtitle={props.subtitle}
      value={props.value}
      containerClassName="form-section-line-item"
      descriptionClassName="form-section-line-item-description"
      valueClassName="form-section-line-item-value"
    />
  );
}

export function SubsectionItem(props: {
  description?: React.ReactElement | string | null;
  title?: React.ReactElement | string;
  subtitle?: React.ReactElement | string;
  value?: React.ReactElement | string | null;
}) {
  return (
    <BaseItem
      description={props.description}
      title={props.title}
      subtitle={props.subtitle}
      value={props.value}
      containerClassName="form-subsection-line-item"
      descriptionClassName="form-subsection-line-item-description"
      valueClassName="form-subsection-line-item-value"
    />
  );
}

export function FormTable(props: {
  columns: { title?: string; width: string }[];
  rows: {
    descriptions: (React.ReactElement | null)[];
    value?: React.ReactElement | string | null;
  }[];
}) {
  const tableRows = [];
  for (const row of props.rows) {
    tableRows.push(
      <div className="form-table-row">
        <div className="form-table-row-description">
          {props.columns.map((c, i) => (
            <div
              className="form-table-row-item"
              style={{ flexBasis: c.width }}
              key={c.title ?? i}
            >
              {props.columns[i].title && (
                <div className="input-label">{props.columns[i].title}</div>
              )}

              <div className="flex">{row.descriptions[i]}</div>
            </div>
          ))}
        </div>
        <div className="form-table-row-value">{row.value}</div>
      </div>,
    );
  }
  return <div className="form-table">{tableRows}</div>;
}
